import languageStore from "stores/languageStore"

let translate = languageStore.translate
let translateText = languageStore.translateText

export {translate, translateText}



// WEBPACK FOOTER //
// ./src/translate.js